import ErrorSection from 'modules/errors/section/ErrorSection';
import {NOT_FOUND_INFO} from 'modules/errors/constants';
import {useEffect} from 'react';
import {NEXT_PUBLIC_YM_COUNTER_NUMBER} from 'core/helpers/env';

const NotFoundPage = () => {
    const {statusCode, description, buttonText, href} = NOT_FOUND_INFO;

    useEffect(() => {
        if ('function' === typeof ym) {
            ym(NEXT_PUBLIC_YM_COUNTER_NUMBER, 'reachGoal', 'ERROR_PAGE_page_view');
        }
    }, []);

    return <ErrorSection buttonText={buttonText} description={description} href={href} statusCode={statusCode} />;
};

export default NotFoundPage;
